export default __webpack_public_path__ + "0fd4e6a5e6970f6fd8817cb78d4445ec.svg";